/**
* @describe 受注データ取込の検討と対応
* @Author Wjx
* @Date 2024/12/16
**/

import { useHttp } from '@/api';
import { httpApi } from '@/api/api';

/**
 * 受注データ取込一覧：検索条件リストの初期化(取込担当者、受注状態)
 */
export function initDataImportSearchList() {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.InitDataImportSearchList)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 *  受注データ取込一覧：検索受注データ取込台帳基本情報
 */
export function getDataImportBasicInfo(data) {

  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetDataImportBasicInfo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 *  受注データ取込一覧：削除受注データ取込基本情報
 */
export function deleteDataImportBasicInfo(data) {

  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.DeleteDataImportBasicInfo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 受注データ取込詳細：リストの初期化（取込担当者、タイプ、受注状態、得意先、仕入先、工場）
 */
export function initDataImportDetailList() {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.InitDataImportDetailList)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}


/**
 * 受注データ取込詳細：検索受注データ取込詳細情報
 */
export function searchDataImportDetailByDibNo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.searchDataImportDetailByDibNo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 受注データ取込詳細：得意先担当者リストの取得
 */
export function initDataImportDetailCusUserList(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.InitDataImportDetailCusUserList, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
/**
 * 得意先コードリスト(受注担当者コードで）の取得
 */
export function getCusCodeForUserInfo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetCusCodeForUserInfo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

// /**
//  * 採番詳細：新規採番台帳情報
//  */
// export function addNumberInfo(data, callBackFn) {
//   return new Promise((resolve, reject) => {
//     useHttp()
//       .request(httpApi.AddNumberInfo, data)
//       .then(res => {
//         resolve(res)
//         callBackFn()
//       })
//       .catch(err => {
//         reject(err)
//       })
//   })
// }



/**
 * 受注データ取込詳細：一時保存・新規
 */
export function addDataImportDetailByDibNo(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.AddDataImportDetailByDibNo, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 受注データ取込詳細：一時保存・変更
 */
export function editDataImportDetailByDibNo(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.EditDataImportDetailByDibNo, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}


/**
 * 受注データ取込詳細：受注データ作成
 */
export function addAcceptInfoByDataImport(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.AddAcceptInfoByDataImport, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}


/**
 * 削除見積選択：削除された「見積No.」を検索する
 */
export function searchRemovableQuoteNoByDIdNo(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchRemovableQuoteNoByDIdNo, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 削除見積選択：選択した「見積No.」を削除する
 */
export function deleteDataImportInfoByQuoteNo(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.DeleteDataImportInfoByQuoteNo, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}





